module.exports = __webpack_public_path__ + "static/media/award.3fd51814.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_130/image/award.png
// module id = 1163
// module chunks = 0